import moment from 'moment'
import { AnalyticsLayer } from '@opallabs/quanta'
import { getSelectedValues, contentFilterSieve } from '../ContentFilter/helpers'
import ExportToCSV from '../ExportToCSV'

const defaultFilename = () =>
  `Opal_Content_Export_${moment().format('MMDDYYYY')}`

const formatIncludesToCsvExcludes = (include) =>
  include ? [''] : ['content_options']

export const csvParams = (opts) => {
  const preCsvParams = {
    brandId: opts.workspaceId,
    dataType: 'post',
    sort: opts.sort,
    filterAttributes: {
      filename: opts.filename,
      account_ids: opts.accountIds,
      label_ids: opts.labelIds,
      post_statuses: opts.postStatuses,
      scheduled_end_at: opts.endDate,
      scheduled_start_at: opts.startDate,
      search_terms: [opts.searchTerms],
      includes_content_by_duration: opts.includesContentByDuration,
      service_ids: opts.serviceIds,
      story_ids: opts.storyIds,
      moment_ids: [opts.currentMomentId],
      content_options: formatIncludesToCsvExcludes(opts.contentOptions),
    },
  }
  if (opts.searchTerms === '') {
    delete preCsvParams.filterAttributes.search_terms
  }

  return preCsvParams
}

export const getValues = (props, storyFilterTree) => {
  const values = getSelectedValues(props, storyFilterTree)

  if (props.activeAccount) {
    return [...values, props.activeAccount]
  }

  if (
    props.currentMomentId &&
    !values.includes(`moment-${props.currentMomentId}`)
  ) {
    return [...values, `moment-${props.currentMomentId}`]
  }

  return values
}

const ContentExport = (props) => {
  return (
    <AnalyticsLayer name="Content Export">
      <ExportToCSV
        {...props}
        withDateRange={true}
        withContentOptions={true}
        title="Export CSV &bull; Content"
        filenamePlaceholder="E.g. Monthly Content Data"
        searchPlaceholder="Search all content"
        csvParams={csvParams}
        filterSieve={contentFilterSieve}
        defaultFilename={defaultFilename()}
      />
    </AnalyticsLayer>
  )
}

export default ContentExport
